export default "__VITE_ASSET__D3B9UPRd__"